import { isProxyAvailable as s, getTarget as n, getDevtoolsGlobalHook as P } from "./env.js";
import { HOOK_SETUP as a } from "./const.js";
import { ApiProxy as E } from "./proxy.js";
function m(i, o) {
  const t = i, _ = n(), r = P(), l = s && t.enableEarlyProxy;
  if (r && (_.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !l))
    r.emit(a, i, o);
  else {
    const e = l ? new E(t, r) : null;
    (_.__VUE_DEVTOOLS_PLUGINS__ = _.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: t,
      setupFn: o,
      proxy: e
    }), e && o(e.proxiedTarget);
  }
}
export {
  m as setupDevtoolsPlugin
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@vue_devtools-api@6.6.4/~/@vue/devtools-api/lib/esm/index.js
// module id = 1319
// module chunks = 41